export default __webpack_public_path__ + "static/logo-5832cfb59c2e2c7d3fb169402727b7e3.svg";